import React from "react";
import {
    Box,
    VStack,
    Center,
    Heading,
    Text,
    Flex,
    Stack,
    Link,
    Button,
    useColorModeValue,
    theme,
} from "@chakra-ui/react";
import { getList } from "controllers/bookmark";
import Tweets from "components/tweets";
import { CustomHead } from "components/custom-head";

import { Header } from "components/tweets-public/header";
import { Footer } from "components/tweets-public/footer";
import { Navbar } from "components/navbar";
import { Logo } from "components/logo";
import { getAllPosts } from "controllers/seo";
import { firebaseClient } from "../firebaseClient";
import { useSession } from "next-auth/client";
import { useFirebaseUser } from "../utils/useFirebaseUser";
import { Page } from "components/page";
import { TrendList } from "components/trend-list";
import { XYPlot, XAxis, YAxis, HorizontalGridLines, LineSeries, VerticalBarSeries } from 'react-vis';

import ReactMarkdown from 'react-markdown';

// export default function Post() {
export default function Trending({ topics, chartData, paths }) {

    const [session, loading] = useSession();
    const isAuthenticated = useFirebaseUser();
    const [refresh, refresher] = React.useState({});

    return (
        <Box maxW={1400} w="100%" margin="auto">
            {/* <Navbar/> */}
            <CustomHead
                title={"Trending Topics on X"}
                desc={"Top trending topics and tweets from the last day."}
                url={"https://tweethunter.io/trending-day"}
            />
            <Header customLink="https://tweethunter.io?utm_source=trending&utm_medium=free-tool" />
            <Box maxW={1000} margin="auto" p={4} mt={10} pb={10}>
                <Stack spacing={10}>
                    <Stack spacing={5} p={10} bg="linear-gradient(20deg, #144461,#091E2B)" color="white">
                        <Heading as="h1" fontSize="5xl">
                            {
                                `Looking for the best trending Tweet?`
                            }
                        </Heading>
                        <Flex>
                            <Text fontWeight={600} mr={3}>by</Text>
                            <Logo h="8" forceWhiteLogo={true} overrideSmallerThan600={true} preserveText={true} />
                        </Flex>
                    </Stack>
                    <Flex flexDirection="column">
                        <Heading as="h2" fontSize="3xl">
                            Here are the top trending topics right now on X
                        </Heading>
                        <Text mt={2} whiteSpace="pre-line">
                            Tweet Hunter analyzes huge number of tweets and tries to extract the most trending topics so you always know what to tweet about to stay hot.
                        </Text>
                    </Flex>

                    <TrendList topics={topics} />

                </Stack>

                <Footer id={"trending-day"} url={"https://tweethunter.io/trending-day"} title={"What’s trending on X? | Tweet Hunter"} description={"Discover what’s trending on X right now. Our AI analyzes millions of tweets every day to uncover trending topics."} paths={paths} />
            </Box>
        </Box>
    );
}

export async function getServerSideProps({ params, res }) {

    const response = await fetch("https://us-central1-ez4cast.cloudfunctions.net/tweetListening-getTrending?isRelative=0&mode=Monthly&sorting=relativePopularity&count=20");
    const json = await response.json();
    const data = json.data;

    // data.topics.forEach(topic => {
    //     let avgFreq = topic.freqTime.reduce(function(a,b){return a+b;}) / topic.freqTime?.length;
    //     topic.relativeFrequency = ((topic.freqTime[topic.freqTime?.length-2] + topic.freqTime[topic.freqTime?.length-1])/2 - avgFreq);
    // });

    // data.topics.forEach(topic => {
    //     let avgLike = topic.likeTime.reduce(function(a,b){return a+b;}) / topic.likeTime?.length;
    //     topic.relativePopularity = topic.popularity * ((1*topic.likeTime[topic.likeTime?.length-3] + 2*topic.likeTime[topic.likeTime?.length-2] + 4*topic.likeTime[topic.likeTime?.length-1])/7 - avgLike) / avgLike;
    // });

    // data.topics = data.topics.sort((a, b) => b.relativePopularity - a.relativePopularity);
    // data.topics = data.topics.slice(0, 20);

    res.setHeader('Cache-Control', 'public, max-age=86400'); // 24 hours
    // console.log({data});

    let paths = await getAllPosts();
    data.paths = paths;

    return {
        props: data ?? {},
    };
}